import { Navigate } from 'react-router-dom'
import { useAuthStore } from '@/lib/store'

const ADMIN_EMAILS = ['509aem@gmail.com', 'aemfamily509@gmail.com']

export function AdminRoute({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((state) => state.user)
  const loading = useAuthStore((state) => state.loading)

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    )
  }

  // Check if user is logged in and has admin email
  if (!user?.email || !ADMIN_EMAILS.includes(user.email)) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}